import { z } from 'zod/v4'
import type { ObjectFormField } from '../lib/form-field.js'
import { getFormFromSchema } from '../lib/zod.js'

export const useSchemaForm = (schema: z.ZodTypeAny) => {
  const form = getFormFromSchema(schema)
  return form as ObjectFormField
}
